import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import Substructure from '@Pages/RetroSynthesis/ProjectParametersDialog/Substructure/Substructure';
import { PredictedIktosParams } from '../../constants';

import './IntermediatesParameter.scss';

function IntermediatesParameter({ smiles, paramName }) {
  const [visible, setVisible] = useState(false);
  const label = paramName === PredictedIktosParams.INCLUDE_SUBSTRUCTURES ? 'included' : 'excluded';
  if (paramName === PredictedIktosParams.EXCLUDE_SUBSTRUCTURES && !smiles) {
    return null;
  }
  return (
    <div className="intermediates-param predicted-param">
      <div className="intermediates-param__header" id={paramName}>
        <div className="intermediates-param__header-title">
          {smiles && (
            <>
              <b>{smiles.length}</b> intermediates {label}
            </>
          )}
          {!smiles && (
            <>
              <b>No</b> intermediates defined
            </>
          )}
        </div>
        {smiles && smiles.length > 0 && (
          <ButtonWithIcon
            type="link"
            size="small"
            sprite={visible ? 'ChevronUp' : 'ChevronDown'}
            linkIconSize="xs"
            iconRight
            onClick={() => setVisible(!visible)}
            className="intermediates-param__header-button e2e-intermediates-section-toggle"
            aria-expanded={visible}
            aria-controls={`${paramName}Content`}
            aria-label="Toggle intermediates">
            {visible ? 'Hide' : 'Show'}
          </ButtonWithIcon>
        )}
      </div>
      {visible && (
        <div className="intermediates-param__content" id={`${paramName}Content`} role="region" aria-labelledby={paramName}>
          {smiles.map((smile) => (
            <Substructure key={smile.value} smiles={smile} displayRemoveIcon={false} />
          ))}
        </div>
      )}
    </div>
  );
}

IntermediatesParameter.propTypes = {
  smiles: PropTypes.array,
  paramName: PropTypes.string,
};

export default IntermediatesParameter;
